import {IResultadoApi} from "../interfaces/IResultadoApi.ts";
import {Request} from "../commons/request.ts";
import {ITema} from "../interfaces/ITema.ts";
import {IResultadoElemento} from "../interfaces/IResultadoElemento.ts";
import {IInformacionPaginacion} from "../interfaces/IInformacionPaginacion.ts";
import {IPaginationResponse} from "base-app/dist/interfaces";


export const Temas = {
    lista: async () => {
        return Request.post<ITema[]>({
            url: `/temas/lista`,
        });
    },
    nuevo: async (tema: ITema) => {
        return Request.post<IResultadoElemento<ITema>>({
            url: `/temas/nuevo`,
            data: tema
        });
    },
    actualizar: async (tema: ITema) => {
        return Request.post<IResultadoElemento<ITema>>({
            url: `/temas/editar`,
            data: tema
        });
    },
    paginacion: async (informacion: IInformacionPaginacion) => {
        return Request.post<IPaginationResponse<ITema>>({
            url: `/temas/paginacion`,
            data: informacion
        });
    },
    porId: async (id: string) => {
        return Request.post<IResultadoElemento<ITema>>({
            url: `/temas/id`,
            data: {id}
        });
    },
    deshabilitar: async (id: string) => {
        return Request.post<IResultadoApi>({
            url: `/temas/deshabilitar`,
            data: {id}
        });
    },
    reestablecer: async (id: string) => {
        return Request.post<IResultadoApi>({
            url: `/temas/restaurar`,
            data: {id}
        });
    },
    eliminar: async (id: string) => {
        return Request.post<IResultadoApi>({
            url: `/temas/eliminar`,
            data: {id}
        });
    },
};